import { render } from "./vm-import-controller.vue?vue&type=template&id=53b4df67&scoped=true"
import script from "./vm-import-controller.vue?vue&type=script&lang=js"
export * from "./vm-import-controller.vue?vue&type=script&lang=js"

import "./vm-import-controller.vue?vue&type=style&index=0&id=53b4df67&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b4df67"]])

export default __exports__